"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7517,2941,2403],{

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3449);
/* harmony import */ var _trust_DpiitBadge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3856);






function Footer() {
    // Extra capabilities shown only in footer
    var footerOnlyCapabilities = [
        {
            name: "Agentic AI Servies & Solutions",
            link: "/services/agentic-ai"
        },
        {
            name: "AI Strategy For Business",
            link: "/outcomes"
        },
        {
            name: "Startup Solutions",
            link: "/startup"
        },
        {
            name: "Data Centre Readiness",
            link: "/services/data-center-project-readiness-governance"
        }, 
    ];
    // Combine both for footer — hub leads the Services group as the flagship practice
    var capabilitiesFooter = [
        {
            name: "Custom Software Development",
            link: "/services/custom-software-development"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_utils_data__WEBPACK_IMPORTED_MODULE_3__/* .capabilitiesNav */ .AQ), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(footerOnlyCapabilities));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
            id: "contact-us",
            className: "bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full items-center justify-between flex-wrap gap-4 md:w-[92%] mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-6 mr-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: "/logo.png",
                                            alt: "logo",
                                            height: "51",
                                            width: "30"
                                        })
                                    }),
                                    "itmtb"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_trust_DpiitBadge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            variant: "dark"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-2 md:grid-cols-5 gap-y-10 gap-x-10 my-8",
                    children: [
                        capabilitiesFooter,
                        _utils_data__WEBPACK_IMPORTED_MODULE_3__/* .industriesNav */ .xW,
                        productsNav,
                        generalPage,
                        contactLinks
                    ].map(function(navList, idx) {
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col space-y-2 items-start md:mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[20px] mb-1 font-semibold text-gray-100/40",
                                    children: ((ref = navList[0]) === null || ref === void 0 ? void 0 : ref.category) || (idx === 0 ? "Capabilities" : "")
                                }),
                                navList.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: item.link,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: item.link.includes("https:") ? "_blank" : "_self",
                                            rel: item.link.includes("https:") ? "noopener" : undefined,
                                            className: "text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white",
                                            children: item.name
                                        })
                                    }, item.link);
                                })
                            ]
                        }, idx);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-left my-10 sm:ml-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-100/40",
                            children: "Locations"
                        }),
                        "Pune | Bhopal",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-100/40",
                            children: "Email"
                        }),
                        "hello@itmtb.com"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-sm",
                    children: [
                        "Copyright \xa9 ",
                        new Date().getFullYear(),
                        " Itmtb Technologies Private Limited"
                    ]
                })
            ]
        })
    });
};
// Footer-specific lists
var contactLinks = [
    {
        name: "Contact Us",
        link: "/contact-us",
        category: "Get in Touch"
    },
    {
        name: "LinkedIn",
        link: "https://www.linkedin.com/company/itmtb/"
    },
    {
        name: "Instagram",
        link: "https://www.instagram.com/itmtbtech/"
    }, 
];
var productsNav = [
    {
        name: "Orchestrik",
        link: "https://orchestrik.ai",
        category: "Products"
    },
    {
        name: "Tomorrow Central",
        link: "/tomorrow-central",
        category: "Products"
    },
    {
        name: "Enterprise Search",
        link: "/enterprise-search",
        category: "Products"
    }, 
];
var generalPage = [
    {
        name: "About Us",
        link: "/discover-itmtb",
        category: "Others"
    },
    {
        name: "Agents at Work",
        link: "/agents-at-work"
    },
    {
        name: "Privacy Policy",
        link: "/privacy_policy.html"
    },
    {
        name: "Careers",
        link: "/career"
    }, 
]; // import Link from "next/link";
 // import Image from "next/future/image";
 // import { capabilitiesNav, industriesNav } from "../utils/data";
 // export default function Footer() {
 //   return (
 //     <section>
 //       <footer id="contact-us" className="bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10">
 //         <div className="flex w-full items-start md:w-[92%] mx-auto">
 //           <Link href="/">
 //             <div
 //               className="
 //             mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2"
 //             >
 //               <div className="w-6 mr-2">
 //                 <Image src="/logo.png" alt="logo" height="51" width="30" />
 //               </div>
 //               itmtb
 //             </div>
 //           </Link>
 //         </div>
 //         <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-10 my-8">
 //           {[capabilitiesNav, industriesNav, generalPage, contactLinks].map((navList, idx) => {
 //             return (
 //               <div key={idx} className="flex flex-col space-y-2 items-start md:mx-auto ">
 //                 <p className="text-[20px] mb-1 font-semibold text-gray-100/40">{navList[0].category}</p>
 //                 {navList.map(item => {
 //                   return (
 //                     <Link key={item.link} href={item.link}>
 //                       <a
 //                         target={item.link.includes("https:") ? "_blank" : "_self"}
 //                         className="text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white"
 //                       >
 //                         {item.name}
 //                       </a>
 //                     </Link>
 //                   );
 //                 })}
 //               </div>
 //             );
 //           })}
 //         </div>
 //         <div className="text-left my-10 sm:ml-4">
 //           <p className="text-gray-100/40">Locations</p>
 // 		  Pune | Mumbai | Bhopal
 //           <p className="text-gray-100/40">Email</p>
 // 	 hello@itmtb.com
 //         </div>
 //         <p className="text-sm">Copyright © {new Date().getFullYear()} Itmtb Technologies Private Limited</p>
 //       </footer>
 //     </section>
 //   );
 // }
 // const contactLinks = [
 //   {
 //     name: "Contact Us",
 //     link: "/contact-us",
 //     category: "Get in Touch",
 //   },
 //   {
 //     name: "LinkedIn",
 //     link: "https://www.linkedin.com/company/itmtb/",
 //   },
 //   {
 //     name: "Instagram",
 //     link: "https://www.instagram.com/itmtbtech/",
 //   },
 // ];
 // const generalPage = [
 //   {
 //     name: "About Us",
 //     link: "/discover-itmtb",
 //     category: "Others",
 //   },
 //   {
 //     name: "Privacy Policy",
 //     link: "/privacy_policy.html",
 //   },
 //   {
 //     name: "Careers",
 //     link: "/career",
 //   },
 // ];


/***/ }),

/***/ 6525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4998);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8388);





// const ButtonArrow = ({ link, txt, style }) => {
//   return (
//     <div className={twMerge(`relative text-slate-900 `, style)}>
//       <Link href={link}>
//         <div className="flex gap-0 hover:gap-2 ml-2 hover:tracking-wider duration-200 transition-all whitespace-nowrap tracking-wide text-xl xs:text-2xl pb-1 mt-7 font-medium  border-b-2 border-gray-500 cursor-pointer">
//           {txt}
//           <span aria-hidden="true" className="ml-2">
//             &rarr;
//           </span>
//         </div>
//       </Link>
//     </div>
//   );
// };
// export default ButtonArrow;
var ButtonArrow = function(param) {
    var link = param.link, txt = param.txt, style = param.style, btnStyle = param.btnStyle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m6)("relative text-slate-900", style),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m6)("flex text-xl tracking-wide items-center mt-2 font-medium cursor-pointer hover:translate-x-1 hover:text-[#f1aa4e] duration-200 transition-all w-fit", btnStyle),
                children: [
                    txt,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": "true",
                        className: "text-[#f1aa4e] sm:text-inherit",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonArrow);


/***/ }),

/***/ 2471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6703);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(615);
// import React from "react";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";
// const CarouselContainer = ({ children }) => {
//   return (
//     <div className=" w-full flex flex-col justify-center items-center md:bg-black  md:border-none md:px-48">
//       <div className="flex flex-col justify-center items-center pt-4 sm:pt-0 sm:py-8 md:py-6 w-full lg:w-10/12">
//         <Carousel
//           autoPlay
//           infiniteLoop
//           interval={3000}
//           itemsToShow={1}
//           itemsToScroll={1}
//           breakPoints={[
//             {
//               width: 1,
//               itemsToShow: 1,
//               itemsToScroll: 1,
//               showArrows: false,
//             },
//           ]}
//           className="h-auto w-screen"
//           showStatus={false}
//           showThumbs={false}
//           showIndicators={false}
//         >
//           {children}
//         </Carousel>
//       </div>
//     </div>
//   );
// };
// export default CarouselContainer;




var CarouselContainer = function(param) {
    var children = param.children;
    // Prevent vertical scrolling from triggering carousel navigation
    var handleWheel = function(e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            e.stopPropagation();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full flex flex-col justify-center items-center md:bg-black md:border-none md:px-48",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col justify-center items-center pt-4 sm:pt-0 sm:py-8 md:py-6 w-full lg:w-10/12",
            onWheel: handleWheel,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_3__/* .Carousel */ .lr, {
                autoPlay: true,
                infiniteLoop: true,
                interval: 3000,
                className: "h-auto w-screen",
                showStatus: false,
                showThumbs: false,
                showIndicators: false,
                swipeable: true,
                emulateTouch: true,
                preventMovementUntilSwipeScrollTolerance: true,
                swipeScrollTolerance: 50,
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselContainer);


/***/ }),

/***/ 5833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5791);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8388);




var FullScreenModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, children = param.children, styleClass = param.styleClass;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
            initial: {
                x: "100%"
            },
            animate: {
                x: 0
            },
            transition: {
                duration: 0.5
            },
            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m6)("fixed top-0 z-[100] left-0 w-screen min-h-screen bg-black bg-opacity-50 flex justify-center items-center", styleClass),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
                initial: {
                    x: "100%"
                },
                animate: {
                    x: 0
                },
                transition: {
                    duration: 0.5
                },
                className: "bg-[#402A6A] rounded-lg shadow-lg w-full w-screen min-h-screen ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "p-4 bg-gray-300 flex justify-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: onClose,
                            className: "text-black hover:text-gray-800 focus:outline-none",
                            children: "Close"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "p-6 ",
                        children: children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullScreenModal);


/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CapabilityCard": function() { return /* binding */ CapabilityCard; },
/* harmony export */   "CapabilityCard2": function() { return /* binding */ CapabilityCard2; },
/* harmony export */   "default": function() { return /* binding */ Capabilities2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3193);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5791);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _reusable_ButtonArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6525);
/* harmony import */ var _utils_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3449);
/* harmony import */ var _hooks_useScreenSize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5344);
/* harmony import */ var _reusable_FullScreenModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5833);
/* harmony import */ var _reusable_CarouselContainer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2471);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8388);













var BlogCardDesign3 = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7261)]).then(__webpack_require__.bind(__webpack_require__, 7261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7261)
            ];
        }
    },
    ssr: false
});
function Capabilities2(param) {
    var dataList = param.dataList, bg = param.bg, insights = param.insights, _hideFooter = param.hideFooter, hideFooter = _hideFooter === void 0 ? false : _hideFooter, _hideCardSubtitle = param.hideCardSubtitle, hideCardSubtitle = _hideCardSubtitle === void 0 ? false : _hideCardSubtitle;
    var size = (0,_hooks_useScreenSize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var isSmall = size == "sm" || size == "md";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), selectedItem = ref[0], setselectedItem = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), currentBlog = ref1[0], setcurrentBlog = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        open: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    }), modalConfig = ref2[0], setmodalConfig = ref2[1];
    var isSmallRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(isSmall);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        isSmallRef.current = isSmall;
        if (!!size) {
            if (isSmall) {
                setselectedItem("");
            } else {
                setselectedItem(dataList[0]["key"]);
            }
        }
    }, [
        isSmall,
        size
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var contentIdx = dataList.findIndex(function(item) {
            return item.key === selectedItem;
        });
        if (contentIdx != -1) {
            var selected = dataList[contentIdx];
            setcurrentBlog({
                title: selected.title,
                subtitle: selected.text,
                img: selected.img
            });
            if (isSmallRef.current) {
                setmodalConfig({
                    open: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CapabilityCard, {
                        title: selected.title,
                        subtitle: selected.text
                    })
                });
            }
        }
    }, [
        selectedItem
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                id: "capabilities",
                className: "min-h-screen ".concat(bg ? bg : "bg-slate-700", " flex flex-col pt-10 text-center   "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-white pt-3 pb-20 text-3xl text-left font-semibold w-[90%] mx-auto",
                        children: "Our Capabilities"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-wrap gap-4 justify-evenly mb-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between mt-2 w-[90%] ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[100%] md:w-[50%] text-black cursor-pointer ",
                                    children: isSmall ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_CarouselContainer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        children: dataList.map(function(capability) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " mb-6 py-4 px-4 w-[90%] mx-auto",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CapabilityCard2, {
                                                    title: capability.key,
                                                    subtitle: capability.title,
                                                    img: capability.img,
                                                    onHoverStart: function() {
                                                        return setselectedItem(capability.key);
                                                    },
                                                    activeItem: selectedItem,
                                                    isSmall: isSmall,
                                                    hideSubtitle: hideCardSubtitle
                                                }, capability.key)
                                            }, capability.key);
                                        })
                                    }) : dataList.map(function(capability) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CapabilityCard2, {
                                            title: capability.key,
                                            subtitle: capability.title,
                                            img: capability.img,
                                            onHoverStart: function() {
                                                return setselectedItem(capability.key);
                                            },
                                            activeItem: selectedItem,
                                            isSmall: isSmall,
                                            hideSubtitle: hideCardSubtitle
                                        }, capability.key);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "hidden md:block md:w-[45%] sticky top-[90px] self-start",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: selectedItem && (currentBlog === null || currentBlog === void 0 ? void 0 : currentBlog.title) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CapabilityCard, {
                                            title: currentBlog.title,
                                            subtitle: currentBlog.subtitle,
                                            inactiveColor: "white"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-white pt-3 pb-10 text-3xl text-left font-semibold w-[90%] mx-auto",
                        children: "Our Work"
                    }),
                    isSmall ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_CarouselContainer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: insights.map(function(post) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-6 py-4 px-4 w-[80%] sm:w-[60%] mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlogCardDesign3, {
                                    img: post.meta.img,
                                    title: post.meta.title,
                                    subheading: post.meta.subtitle,
                                    slug: post.meta.slug,
                                    badge: (0,_utils_data__WEBPACK_IMPORTED_MODULE_6__/* .badgeMapper */ .zr)(post.meta.category)
                                })
                            }, post.meta.title);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mx-auto mb-2 w-[90%]",
                        children: insights.map(function(post) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-6 py-4 px-4 mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlogCardDesign3, {
                                    img: post.meta.img,
                                    title: post.meta.title,
                                    subheading: post.meta.subtitle,
                                    slug: post.meta.slug,
                                    badge: (0,_utils_data__WEBPACK_IMPORTED_MODULE_6__/* .badgeMapper */ .zr)(post.meta.category)
                                })
                            }, post.meta.title);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[90%] flex flex-col md:flex-row mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full pt-[100px] pb-[30px] grid grid-cols-2 md:grid-cols-4 place-items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_ButtonArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    link: "/capabilities",
                                    txt: "Capabilities",
                                    style: "text-sm md:text-lg [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8] "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_ButtonArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    link: "/capabilities#Industry",
                                    txt: "Industries",
                                    style: "text-sm md:text-lg [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_ButtonArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    link: "/success-stories",
                                    txt: "Success Stories",
                                    style: "text-sm md:text-lg [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_ButtonArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    link: "/career",
                                    txt: "Careers",
                                    style: "text-sm md:text-lg [&>div]:border-b-[0px] text-gray-200 hover:text-opacity-[0.8]"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[90%] mx-auto mt-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-white md:p-3 md:mx-6 mt-20 mb-10 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "py-5 text-xl ",
                                children: [
                                    "ITMTB helps companies build, operate, and improve business-critical technology systems through software engineering, cloud operations, cybersecurity, AI deployment, and managed services.",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                                        href: "/contact-us",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "font-bold underline underline-offset-4 cursor-pointer mx-2",
                                            children: "Let us talk"
                                        })
                                    }),
                                    "and explore how we can help.",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                ]
                            })
                        })
                    })
                ]
            }),
            !hideFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_1__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_FullScreenModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                isOpen: modalConfig.open,
                onClose: function() {
                    setmodalConfig(function() {
                        return {
                            open: false,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                        };
                    });
                    setselectedItem("");
                },
                children: modalConfig.children
            })
        ]
    });
};
var CapabilityCard = function(param) {
    var title = param.title, subtitle = param.subtitle, img = param.img, activeItem = param.activeItem, _hideTitle = param.hideTitle, hideTitle = _hideTitle === void 0 ? false : _hideTitle, imgStyle = param.imgStyle, styleClass = param.styleClass, knowMoreLink = param.knowMoreLink, _inactiveColor = param.inactiveColor, inactiveColor = _inactiveColor === void 0 ? "grey" : _inactiveColor;
    var isActive = activeItem === title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion.div */ .E.div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1,
            color: isActive ? "white" : inactiveColor
        },
        transition: {
            duration: 0.7
        },
        style: {
            color: inactiveColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_12__/* .twMerge */ .m6)("flex flex-col items-start ", styleClass),
            children: [
                img ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:block mr-4 mb-4 mb:mb-0 flex-shrink-0 self-center w-[95%] ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                        src: img,
                        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_12__/* .twMerge */ .m6)("w-full h-auto md:h-[300px] mx-auto object-cover", imgStyle),
                        width: "500",
                        height: "500",
                        priority: true,
                        alt: title,
                        sizes: "(max-width: 500px) 100vw, (max-width: 1200px) 70vw, 100vw",
                        placeholder: "blur",
                        blurDataURL: img
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                !hideTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-xl md:text-3xl text-left font-semibold",
                    children: title
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-md md:text-[21px] leading-7 text-left mt-6 mb-4",
                    dangerouslySetInnerHTML: {
                        __html: subtitle
                    }
                }),
                knowMoreLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                    href: knowMoreLink,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center text-lg gap-7 hover:opacity-[0.8] cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: " Know more "
                        })
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            ]
        })
    }, title);
};
var CapabilityCard2 = function(param) {
    var title = param.title, subtitle = param.subtitle, onHoverStart = param.onHoverStart, img = param.img, activeItem = param.activeItem, isSmall = param.isSmall, _fadeTxtColor = param.fadeTxtColor, fadeTxtColor = _fadeTxtColor === void 0 ? "gray" : _fadeTxtColor, imgStyle = param.imgStyle, styleClass = param.styleClass, _activeTxtColor = param.activeTxtColor, activeTxtColor = _activeTxtColor === void 0 ? "white" : _activeTxtColor, _hideBtn = param.hideBtn, hideBtn = _hideBtn === void 0 ? false : _hideBtn, _hideSubtitle = param.hideSubtitle, hideSubtitle = _hideSubtitle === void 0 ? false : _hideSubtitle;
    var isActive = activeItem === title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion.div */ .E.div, {
        transition: {
            duration: 0.3
        },
        animate: isSmall ? {} : {
            x: isActive ? 30 : 0,
            color: isActive ? activeTxtColor : fadeTxtColor
        },
        style: {
            color: isSmall ? "#ffffff" : fadeTxtColor
        },
        onHoverStart: !isSmall && onHoverStart,
        onClick: isSmall ? onHoverStart : function() {},
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_12__/* .twMerge */ .m6)("flex flex-col md:flex-row text-white px-2 pb-2 mb-8 rounded", styleClass),
        children: [
            img ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " md:block mr-4 flex-shrink-0 self-center ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: img,
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_12__/* .twMerge */ .m6)("w-[90vw] md:w-auto h-auto  md:h-[150px] mx-auto object-cover", imgStyle),
                    width: "500",
                    height: "500",
                    priority: true,
                    alt: "how-digitisation-helps-formulation-companies",
                    sizes: "(max-width: 500px) 100vw, (max-width: 1200px) 70vw, 100vw",
                    placeholder: "blur",
                    blurDataURL: img
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-left mt-5 md:mt-0 whitespace-pre-line",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "text-2xl md:text-2xl font-bold",
                        children: title
                    }),
                    !hideSubtitle && subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-4 text-lg md:text-xl md:text-[21px] ",
                        children: subtitle
                    })
                ]
            }),
            !hideBtn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "block md:hidden mt-5 text-lg text-left",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        "View more",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            "aria-hidden": "true",
                            className: "ml-2",
                            children: "→"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
};


/***/ }),

/***/ 3856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DpiitBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


// DPIIT / Startup India recognition credential — single source of truth for
// every placement (footer, about page, homepage trust strip).
//
// Uses the official DPIIT + #startupindia recognition logo supplied by the
// Startup India programme (ITMTB is a recognised startup). The logo carries the
// national emblem + wordmarks, so it sits on a white chip to stay legible on any
// surface (including the dark footer). The recognition number is the extra
// verifiable fact the logo itself does not carry.
var RECOGNITION_NO = "DIPP274362";
var LOGO_SRC = "/dpiit-startupindia.webp";
var LOGO_W = 1969;
var LOGO_H = 655;
function DpiitBadge(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "light" : _variant, _bare = param.bare, bare = _bare === void 0 ? false : _bare, _className = param.className, className = _className === void 0 ? "" : _className;
    var logoHeight = variant === "dark" ? "h-7" : "h-9";
    var chrome = bare ? "" : "rounded-lg border border-gray-200 bg-white px-4 py-2.5 shadow-sm";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "inline-flex items-center gap-3 ".concat(chrome, " ").concat(className),
        "aria-label": "Recognised by DPIIT under the Startup India initiative, recognition number ".concat(RECOGNITION_NO),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: LOGO_SRC,
                alt: "Recognised by DPIIT — Startup India",
                width: LOGO_W,
                height: LOGO_H,
                className: "".concat(logoHeight, " w-auto shrink-0")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "h-8 w-px bg-gray-200 shrink-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "leading-tight text-left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[10px] font-semibold uppercase tracking-wider text-gray-400",
                        children: "Recognised"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-sm font-semibold text-gray-900",
                        children: [
                            "Reg. No. ",
                            RECOGNITION_NO
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 3449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ capabilitiesNav; },
/* harmony export */   "xW": function() { return /* binding */ industriesNav; },
/* harmony export */   "zR": function() { return /* binding */ categoriesData; },
/* harmony export */   "zr": function() { return /* binding */ badgeMapper; }
/* harmony export */ });
/* unused harmony exports capabilities, careerData, careerLookingFor */
var capabilities = (/* unused pure expression or super */ null && ([
    "Cloud",
    "Cyber Security",
    "Data and Artificial Intelligence",
    "Enterprise Applications and Automation",
    "IoT and Digital Engineering",
    "Managed Services",
    "Marketing & Experience",
    "Quality Engineering",
    "Strategy",
    "Sustainability",
    "Talent & Learning",
    "Technology Consulting", 
]));
var capabilitiesNav = [
    {
        name: "Cloud",
        link: "/services/cloud",
        category: "Capabilities"
    },
    {
        name: "Cyber Security",
        link: "/services/cybersecurity"
    },
    {
        name: "AI Agents & Automation",
        link: "/services/analytics-ai-automation"
    },
    {
        name: "Forward Deployed Engineering",
        link: "/services/forward-deployed-engineering"
    },
    {
        name: "Enterprise Applications and Automation",
        link: "/services/enterprise-applications"
    },
    {
        name: "IoT and Digital Engineering",
        link: "/services/iot-and-digital-eng"
    },
    {
        name: "Managed Services",
        link: "/services/managed-services"
    },
    {
        name: "Quality Engineering",
        link: "/services/quality-engineering"
    },
    {
        name: "Strategy",
        link: "/services/strategy"
    },
    {
        name: "Technology Consulting",
        link: "/services/technology-consulting"
    },
    {
        name: "Tech Stack Audit",
        link: "/services/tech-stack-audit"
    }, 
];
var industriesNav = [
    {
        name: "Banking",
        link: "/industry/banking",
        category: "Industries"
    },
    {
        name: "Insurance",
        link: "/industry/insurance"
    },
    {
        name: "Life Sciences",
        link: "/industry/life-sciences"
    },
    {
        name: "Retail",
        link: "/industry/retail"
    },
    {
        name: "Supply Chain",
        link: "/industry/supply-chain"
    }, 
];
var badgeMapper = function(badge) {
    if (badge === "case-study") return "Success Story";
    return "Insight";
};
var careerData = [
    {
        point: "1. Solve awesome problems",
        pointText: "Whether it is technology, strategy, sales, or marketing, interesting problems find us",
        desc: "From increasing operational efficiency by 400x, to designign the most scalable cloud architecture, to rewriting algorithms to process faster in real time, all the way to discovering the right business strategies for the customer, we do it all.",
        linkText: "Success Stories",
        link: "/blog/success-stories",
        img: "/career/career - technlogies.webp"
    },
    {
        point: "2. Work across industries",
        pointText: "Our universe is truly parallel. Which one would you like?",
        desc: " Be it D2C retail, supply chain, pharma and life sciences, fintech and more, you get to expose yourself to an unparalleled diversity of business problems.",
        linkText: "",
        link: "",
        img: "/career/career - diverse industries.webp"
    },
    {
        point: "3. Have a little fun while you do it",
        pointText: "Road trips, anyone?",
        desc: "Enjoy not just the grind but also the unwinds. From unplanned road-trips to goofy ittle things, we’ve got the spirit to make every day at work ridiculously entertaining.",
        linkText: "",
        link: "",
        img: "/career/career - fun.webp"
    }, 
];
var careerLookingFor = [
    {
        title: "You must love solving problems",
        desc: "Problems excite no one. Solutions excite everyone. But only a few are willing to put their backs into finding a solution while the rest give up. You are not 'the rest.'"
    },
    {
        title: "Technology is just another toolkit in your bag",
        desc: "Can you only solve a problem if its within your skills. What do you do when needed to learn something new and deliver quickly?"
    },
    {
        title: "You must understand the value of helping your mates",
        desc: " Remember a leading runner slowing down to help his fallen competitor? Would you slow down if you knew your team mate really needed your help?"
    }, 
];
var categoriesData = [
    {
        title: "Design",
        desc: "Change is the only constant. Reinvent your business with the right strategy and technology implementations."
    },
    {
        title: "Build",
        desc: "Technology is often the key differentiator. Get the technology you need to lead the competition."
    },
    {
        title: "Improve",
        desc: "Right quality and mature operations hold the key to cost efficiency. Rediscover them."
    },
    {
        title: "Protect",
        desc: "It is important to build. It is even more imporant to protect. Safeguard your digital assets."
    }, 
]; // {
 //     "slug": "",
 //     "metaDesc": "",
 //     "metaKeyword": "",
 //     "image": "",
 //     "paragraph": "",
 //     "heading": "",
 //     "mainHeading": "",
 //     "numbers": [
 //         {
 //             "number": "",
 //             "detail": ""
 //         },
 //     ],
 //     "details": {
 //         "title": "",
 //         "summary": "",
 //         "listItems": [
 //             "",
 //         ]
 //     },
 //     "points": [
 //         {
 //             "key": "",
 //             "title": "",
 //             "text": ""
 //         },
 //     ],
 //     "whyChooseUs": ""
 // }


/***/ })

}]);